export default "__VITE_ASSET__7oVgDXqk__"